// Mask sensitive identifiers (Aadhaar/PAN) — show only the last N characters.
export function maskId(v, visible = 4) {
  if (v === undefined || v === null || v === "") return "—";
  const s = String(v).replace(/\s+/g, "");
  if (s.length <= visible) return s;
  return "X".repeat(s.length - visible) + s.slice(-visible);
}
